import {Container} from "./Container"

export const RouterStyled = {
    Container: Container
}